import { render } from "./BgIcon.vue?vue&type=template&id=952f0c74&scoped=true&ts=true"
import script from "./BgIcon.vue?vue&type=script&lang=ts"
export * from "./BgIcon.vue?vue&type=script&lang=ts"

import "./BgIcon.vue?vue&type=style&index=0&id=952f0c74&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-952f0c74"]])

export default __exports__